import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

import { BusinessProcessService } from '../../../services/business-process.service';
import { HumanInteractionService } from '../../../services/human-interaction.service';
import { WebClientConfigurationService } from '../../../services/configuration/web-client-configuration.service';
import { GenericModalService } from '../../../services/generic-modal.service';
import { TotalsPerAgreementsModalComponent } from './totals-per-agreements-modal/totals-per-agreements-modal.component';

@Component({
  selector: 'app-custom-interaction-queue',
  templateUrl: './custom-interaction-queue.component.html',
  styleUrls: ['./custom-interaction-queue.component.css']
})
export class CustomInteractionQueueComponent implements OnInit {

  viewType: InvokeListViewType;
  businessProcessList: any[];
  errorMessage: string;
  rightQueueConfig: any;
  leftQueueConfig: any;
  favoriteListIsFull = false;
  rightQueueIsFav = false;
  leftQueueIsFav = false;
  filterForm: FormGroup;
  rightFilter = {interacting: null, waiting: null};
  leftFilter = {interacting: null, waiting: null};
  totalRight = {interacting: 0, waiting: 0};
  totalLeft = {interacting: 0, waiting: 0};
  pageConfig: any;
  allQueues = [];
  noQueueSelectedOnRight = true;
  noQueueSelectedOnLeft = true;
  agreementsModalComponent: any = TotalsPerAgreementsModalComponent;
  hasColorConfig = {right: false, left: false};

  constructor(
    private formBuilder: FormBuilder,
    private bpService: BusinessProcessService,
    private humanInteractionService: HumanInteractionService,
    private webClientConfig: WebClientConfigurationService,
    private modalService: GenericModalService
  ) { }

  ngOnInit() {
    this.viewType = InvokeListViewType.Grid;
    this.getPageConfig();
    this.createForm();
    this.loadBusinessProcessList();
    this.getCustomQueue();
  }

  loadBusinessProcessList() {
    this.bpService.getPublishedBusinessProcesses.subscribe(
      bpList => this.businessProcessList = bpList,
      error1 => this.errorMessage = error1
    );
  }

  onClickChangeView(type: InvokeListViewType) {
    this.viewType = type;
  }

  changeBusinessProcess(businessProcess) {
    if (businessProcess) {
      this.getCustomQueue(businessProcess.businessProcessId);
    } else {
      this.getCustomQueue();
    }
    this.onClearCustomQueue('right');
    this.onClearCustomQueue('left');
  }

  changeQueue(queue, side) {
    this.errorMessage = '';
    if (queue) {
      this.checkFavorites(queue.id, side);
      this.humanInteractionService.getCustomInteractionQueueConfigById(queue.id)
        .subscribe( queue1 => {
          if (side === 'right') {
            this.hasColorConfig.right = queue1.colors.length > 0;
            this.rightQueueConfig = queue1;
            this.totalRight.interacting = 0;
            this.totalRight.waiting = 0;
            this.noQueueSelectedOnRight = false;
            this.rightFilter.waiting = this.setQueueFilter('notLocked', 'right');
            this.rightFilter.interacting = this.setQueueFilter('locked', 'right');
          }  else {
            this.hasColorConfig.left = queue1.colors.length > 0;
            this.leftQueueConfig = queue1;
            this.totalLeft.interacting = 0;
            this.totalLeft.waiting = 0;
            this.noQueueSelectedOnLeft = false;
            this.leftFilter.waiting = this.setQueueFilter('notLocked', 'left');
            this.leftFilter.interacting = this.setQueueFilter('locked', 'left');
          }
        }, error1 => {
          this.errorMessage = error1;
        });
    } else {
      this.onClearCustomQueue(side);
    }
  }

  onClearCustomQueue(side: string) {
    if (side === 'right') {
      this.filterForm.controls['rightQueue'].setValue(null);
      this.totalRight.interacting = 0;
      this.totalRight.waiting = 0;
      this.noQueueSelectedOnRight = true;
      this.rightQueueIsFav = false;
    }  else {
      this.filterForm.controls['leftQueue'].setValue(null);
      this.totalLeft.interacting = 0;
      this.totalLeft.waiting = 0;
      this.noQueueSelectedOnLeft = true;
      this.leftQueueIsFav = false;
    }
  }


  getCustomQueue(businessProcessId: number = null) {
    this.errorMessage = '';
    this.allQueues = [];
    this.humanInteractionService.getCustomInteractionQueueConfig(businessProcessId)
      .subscribe( queues => {
        if (queues && queues.length > 0) {
          this.allQueues = queues;
          this.filterForm.controls['leftQueue'].setValue(queues[0]['id']);
          this.changeQueue(queues[0], 'left');
          if (queues.length > 1) {
            this.filterForm.controls['rightQueue'].setValue(queues[1]['id']);
            this.changeQueue(queues[1], 'right');
          }
        }
      }, error1 => {
        this.errorMessage = error1;
      });
  }

  checkFavorites(queueId: number, side: string) {
    this.errorMessage = '';
    this.humanInteractionService.getUserFavoriteQueues()
      .subscribe( queues => {
        this.favoriteListIsFull = queues.length >= 2;
        side === 'right' ? this.rightQueueIsFav = queues.includes(queueId)
          : this.leftQueueIsFav = queues.includes(queueId);
      }, error1 => this.errorMessage = error1);
  }

  onHeartClick(queueId: number, isFavorite: boolean, side: string) {
    if (isFavorite) {
      this.errorMessage = '';
      let alert: any;
      alert = this.modalService
        .showConfirmModal('Confirmação de Exclusão', 'Confirma a exclusão da fila da lista de filas favoritas?');
      alert.then( resp => {
        if (resp.value) {
          this.removeQueueFromFavorite(queueId, side);
        }
      });
    } else {
      this.addQueueToFavorite(queueId, side);
    }
  }

  addQueueToFavorite(queueId: number, side: string) {
    this.humanInteractionService.addQueueToFavorite(queueId)
      .subscribe( () => {
        this.modalService.showSuccessMessage('Fila adicionada a lista de favoritas com sucesso', false, 5000);
        this.checkFavorites(queueId, side);
      },
        error1 => {
        this.modalService.showErrorMessage(`${error1}`, true);
      });
  }

  removeQueueFromFavorite(queueId: number, side: string) {
    this.humanInteractionService.removeQueueFromFavorite(queueId)
      .subscribe( () => {
        this.modalService.showSuccessMessage('Fila removida da lista de favoritas com sucesso', false, 5000);
        this.checkFavorites(queueId, side);
      },
        error1 => {
        this.modalService.showErrorMessage(`${error1}`, true);
      });
  }

  setFavQueueTooltipText(isFavorite: boolean, favListIsFull: boolean): string {
    if (isFavorite) {
      return 'Remover fila das favoritas';
    } else {
      if (favListIsFull) {
        return 'A lista de filas favoritas está cheia. Remova uma fila para adicionar outra';
      } else {
        return 'Adicionar a fila às favoritas';
      }
    }
  }

  getPageConfig() {
    this.errorMessage = '';
    this.webClientConfig.getPageConfig()
      .subscribe(pageConfig => {
          this.pageConfig = pageConfig;
        },
        error1 => {
          this.errorMessage = error1;
        });
  }

  getTotal(total: number, side: string, queue: string) {
    if (total) {
      if (side === 'right') {
        queue === 'locked' ? this.totalRight.interacting = total : this.totalRight.waiting = total;
      } else {
        queue === 'locked' ? this.totalLeft.interacting = total : this.totalLeft.waiting = total;
      }
    }
  }

  createForm() {
    this.filterForm = this.formBuilder.group({
      businessProcessId: null,
      columns: null,
      columnsComparisonType: 1,
      customInteractionQueueConfigId: null,
      finalDate: null,
      initialDate: null,
      orderByColumnId: null,
      orderByStateModifyDate: false,
      orderDirection: 0,
      pageIndex: 0,
      pageSize: 0,
      stateId: null,
      stateLifeCycles: null,
      userLogon: null,
      rightQueue: null,
      leftQueue: null
    });
  }

  setQueueFilter(type: string, side: string): any {
    const filter = this.filterForm.getRawValue();
    side === 'right' ?
      filter.customInteractionQueueConfigId = [Number(filter.rightQueue)]
      : filter.customInteractionQueueConfigId = [Number(filter.leftQueue)];
    if (type === 'locked') {
      filter.stateLifeCycles = [8 , 11];
      filter.userLogon = localStorage.getItem('userLogon');
    } else {
      filter.stateLifeCycles = [7];
    }
    return filter;
  }

  onOpenTotalsPerAgreementItems(side: string) {
    let objModal;
    if (side === 'left') {
      objModal = {
        filter: this.leftFilter.waiting,
        hasColors: this.hasColorConfig.left
      };
    } else {
      objModal = {
        filter: this.rightFilter.waiting,
        hasColors: this.hasColorConfig.right
      };
    }
    this.modalService.showObjModal(this.agreementsModalComponent, 'Faixa de cores', objModal);
  }
}

export enum InvokeListViewType {
  Grid = 1,
  Card = 2
}
